import { type NextRequest, type NextResponse } from 'next/server'

import { COOKIE_FEATURE_FLAG_NAME } from '../../cookies/cookieNames'
import { EXPERIMENT_NAME_COMPETERA } from '../model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../model/EXPERIMENT_VARIATION'
import { type ExperimentType } from '../model/Experiment.types'
import { experimentAccessorGetExperimentData } from '../model/experimentAccessor'
import { experimentsMapExperimentsCookieToJson } from '../model/experimentsMapExperimentsCookieToJson'

export const experimentsAlgoliaCompeteraExperimentIsEnabled = (
  experiments: ExperimentType[],
): boolean => {
  const competeraExperiment = experimentAccessorGetExperimentData(
    experiments,
    EXPERIMENT_NAME_COMPETERA,
  )

  return Boolean(competeraExperiment?.isEnabled)
}

export const experimentsAlgoliaCompeteraExperimentIsEnabledAndV1 = (
  experiments: ExperimentType[],
): boolean => {
  const competeraExperiment = experimentAccessorGetExperimentData(
    experiments,
    EXPERIMENT_NAME_COMPETERA,
  )

  return Boolean(
    competeraExperiment?.isEnabled &&
      competeraExperiment.variant === EXPERIMENT_VARIATION.V1,
  )
}

//check if expa=tsta cookie should be set for competera experiment
export const ifShouldSetTstaCookie = ({
  req,
  res,
}: {
  req: NextRequest
  res: NextResponse
}): boolean => {
  const featureFlagCookie =
    res.cookies.get(COOKIE_FEATURE_FLAG_NAME)?.value ??
    req.cookies.get(COOKIE_FEATURE_FLAG_NAME)?.value

  if (!featureFlagCookie || typeof featureFlagCookie !== 'string') {
    return false
  }

  const experiments = experimentsMapExperimentsCookieToJson(featureFlagCookie)

  return experimentsAlgoliaCompeteraExperimentIsEnabledAndV1(experiments)
}
